import foodMenuImage from "../assets/food_menu.png";
import furniture from "../assets/furniture.png";
import ephoto from "../assets/ephoto.jpg";
// import movie_menu from "../assets/movie_menu.png";
import share_mng from "../assets/share_mng.png";
// import bankist from "../assets/bankist.png";
import henok from "../assets/henok.jpg";
import zm from "../assets/zm.jpg";
import bd from "../assets/bd.jpeg";
import athlink from "../assets/athlink.jpg";
import tbk from "../assets/tbk.jpg";
import enaszi from "../assets/enasiz.jpg";
import dryosefdent from "../assets/dryosefdent.png";

export const Bio = {
  name: "Eyob Mekonnen",
  roles: ["Senior Software Engineer"],
  description:
    "I am a self-taught full-stack developer with a passion for coding and continuous learning. My ability to adapt and thrive in fast-paced environments allows me to tackle complex challenges with confidence. With a strong foundation in both front-end and back-end development, I enjoy building scalable, user-friendly applications. My dedication to problem-solving, creativity, and attention to detail ensures that I deliver high-quality results. Driven by curiosity and a growth mindset, I am always eager to learn new technologies and make meaningful contributions to every project I undertake.",
  // description:
  //   "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/eyop23",
  resume:
    "https://drive.google.com/file/d/1yHYN8uGP1SzOYuiNiVI3zYFMCpQFMojU/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
  twitter: "https://x.com/EyobMekonn96731",
  insta: "  https://www.instagram.com/eyopaaaa/",
  telegram: "https://t.me/Eyopaa",
  // facebook: "https://www.facebook.com/rishav.chanda.165/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Golang",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg",
      },
      {
        name: "gRPC",
        image:
          "https://grpc.io/img/logos/grpc-icon-color.png",
      },
      {
        name: "SQLc",
        image:
          "https://raw.githubusercontent.com/sqlc-dev/sqlc/main/docs/logo.png",
      },
      {
        name: "Goose",
        image:
          "https://raw.githubusercontent.com/pressly/goose/master/assets/goose_logo.png",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Kubernetes",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/kubernetes/kubernetes-plain.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Render",
        image:
          "https://seeklogo.com/images/R/render-logo-0DF542A4F8-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
          "https://assets.vercel.com/image/upload/v1662130559/front/favicon/vercel/favicon.ico",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      // {
      //   name: "Figma",
      //   image:
      //     "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      // },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "Software development Intern",
    company: "CUSTOR COMPUTING PLC",
    date: "Jun 2022 – Oct 2022",
    desc: "During the Internship program, I have learned about various aspects of software development, including design,development, testing, deployment. I have worked with different programming languages and tools, such as Angular, ASP. NET,MySQL. I have had the chance to work on real-world projects,collaborate with a team, gain practical experience.",
    skills: [
      "Angualr",
      ".NET",
      "MYSQL",
      "GITHUB",
      "C#",
      "JavaScript",
      "TypeScript",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //   role: "Share Mangement System",
  //   company: "Final Year Project",
  //   date: "Apirl 2023 - Jun 2023",
  //   desc:"enable once to buy and increase share amount with integrated payment system and keep track of their share information and to dividend the share based on their share amount using next js as a front end,expressjs as a backend and mongodb as a database.",
  //   skills: [
  //     "NextJs",
  //     "NodeJs",
  //     "TailwindCss",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //     "Mongodb",
  //   ],
  //   doc: "https://share-mangement-sym.vercel.app/",
  // },
  {
    id: 1,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "BackEnd Developer",
    company: "Etta Solutions Plc",
    date: "Jan 2024 - Present",
    desc: "In my current role at ETTA Solutions PLC, I have contributed to several key projects, including: Zmall delivery using Node.js and angular, where I played a pivotal role in designing and implementing robust server-side solutions. Telebirr payment integration, which enables smooth integration of payment systems by ensuring secure and reliable transaction processing. Mini-app development using Macel and H5 technology, which enhance the mobile user experience. I have also worked on Odoo ERP, customizing and developing modules to automate and streamline business processes such as sales, inventory, and accounting workflows.",
    skills: [
      "ReactJS",
      "Angular",
      "NodeJs",
      "Macel",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "Digtal Ocean",
      "MongoDB",
      "Diaffane SMS Server",
      "Odoo ERP",
    ],
  },
  {
    id: 2,
    img: athlink,
    role: "Backend Developer & DevOps Engineer",
    company: "Athlink, Hong Kong",
    date: "Oct 2024 - Present",
    desc: "Developed complete backend infrastructure using Node.js and MongoDB for a platform connecting athletes with sponsors, handling user authentication, profile management, and matching algorithms. Implemented real-time chat functionality using WebSocket for seamless communication between athletes and sponsors. Deployed and managed the application on DigitalOcean VPS with complete DevOps setup including domain mapping and reverse proxy configuration using NGINX. Integrated FFmpeg for efficient media file compression to optimize storage and bandwidth usage.",
    skills: [
      "Flutter",
      "Node.js",
      "Express.js",
      "MongoDB",
      "WebSocket",
      "FFmpeg",
      "NGINX",
      "DigitalOcean",
    ],
  },
  {
    id: 3,
    img: tbk,
    role: "Web and Mobile App Developer (Freelance)",
    company: "TBK Trading PLC, Sheger City",
    date: "Mar 2025 - May 2025",
    desc: "Designed and developed a full-stack Vehicle Device Inventory Management System to monitor fuel usage and reduce vehicle emissions through installed tracking devices. Built role-based web and mobile applications for administrators, agents, and government inspectors. Implemented admin tools for managing device inventory, agent registrations, and system-wide reports. Developed government features for verifying device installation through search and QR code scanning.",
    skills: [
      "Flutter",
      "Node.js",
      "MongoDB",
      "REST API",
      "React",
    ],
  },
  {
    id: 4,
    img: enaszi,
    role: "Full Stack Developer",
    company: "ENASIZ - Birr Market",
    date: "2024 - Present",
    desc: "Developed Ethiopia's First Fun & Safe Prediction Market App where users can predict viral trends, social media events, and cultural phenomena. Built the complete backend infrastructure using Golang with Gin framework, implementing RESTful APIs and real-time prediction markets. Designed and optimized database architecture using PostgreSQL with SQLc for type-safe SQL queries. Deployed and managed the application on cloud infrastructure with NGINX as reverse proxy. Created an engaging Flutter mobile application allowing users to participate in prediction markets about Ethiopian viral content, celebrity visits, and trending memes.",
    skills: [
      "Flutter",
      "Golang",
      "Gin",
      "SQLc",
      "PostgreSQL",
      "NGINX",
      "REST API",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: bd,
    // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
    school: "Bahir Dar University",
    date: "Oct 2018 - july 2023",
    grade: "3.56 CGPA",
    // desc: "I have completed my Bachelor's degree in Computer Engineering from Bahirdar Institute of Technology(BiT),Bahirdar, with a CGPA of 3.56. During my studies, I took courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor Computer Engineering",
  },
  // {
  //   id: 1,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
  //   school: "Methodist School, Dankuni",
  //   date: "Apr 2019 - Apr 2025",
  //   grade: "88.2%",
  //   desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
  //   degree: "ISC(XII), Science with Computer",
  // },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
  //   school: "Methodist School, Dankuni",
  //   date: "Apr 2017 - Apr 2019",
  //   grade: "92.3%",
  //   desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
  //   degree: "ICSC(X), Science with Computer",
  // },
];

export const projects = [
  {
    id: 0,
    title: "ENASIZ - Birr Market",
    date: "2024 - Present",
    image: enaszi,
    description:
      "Birr Market – Ethiopia's First Fun & Safe Prediction Market App. Have you ever wondered if a viral TikTok will take over the nation? Or if IShowSpeed will meet Adonaye first during his Ethiopia visit? Maybe you've questioned whether a random livestream will spark a new meme or make an unknown Ethiopian go viral. Birr Market lets you turn your curiosity into a fun, interactive experience! Built with Flutter for mobile, Golang (Gin framework) for backend, PostgreSQL with SQLc for type-safe database queries, and deployed with NGINX.",
    tags: [],
    category: "android app",
    github: "https://github.com/eyop23",
    webapp: "https://play.google.com/store/apps/details?id=com.itechsolutions.enasiz",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 1,
    title: "Ethio Payment Verification",
    date: "2024",
    image:
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg",
    description:
      "A Go-based REST API for verifying payments from Ethiopian payment providers (CBE and TeleBirr). Features include verifying CBE bank transfer receipts via PDF parsing, verifying TeleBirr mobile payment receipts via HTML parsing, extracting payment details such as payer, receiver, amount, date, and reference number, and MongoDB storage for payments, users, and providers.",
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23",
    webapp: "https://github.com/eyop23",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 2,
    title: "Athlink - Athletes and Sponsors Platform",
    date: "Oct 2024 - Present",
    image: athlink,
    description:
      "Developed a comprehensive platform connecting athletes with sponsors. Built complete backend infrastructure using Node.js and MongoDB, handling user authentication, profile management, and matching algorithms. Implemented real-time chat functionality using WebSocket for seamless communication between athletes and sponsors. Deployed and managed the application on DigitalOcean VPS with complete DevOps setup including domain mapping and reverse proxy configuration using NGINX. Integrated FFmpeg for efficient media file compression to optimize storage and bandwidth usage.",
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23",
    webapp: "https://athlink.com",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 3,
    title: "TBK Trading PLC - Vehicle Device Inventory System",
    date: "Mar 2025 - May 2025",
    image: tbk,
    description:
      "Designed and developed a full-stack Vehicle Device Inventory Management System to monitor fuel usage and reduce vehicle emissions through installed tracking devices. Built role-based web and mobile applications for administrators, agents, and government inspectors. Implemented admin tools for managing device inventory, agent registrations, and system-wide reports. Developed government features for verifying device installation through search and QR code scanning.",
    tags: [],
    category: "android app",
    github: "https://github.com/eyop23",
    webapp: "https://play.google.com/store/apps/details?id=com.itech.vehiclem",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 4,
    title: "Zmall Food Delivery App",
    date: "Jan 2024 - Present",
    image: zm,
    description:
      "Zmall is a food delivery app developed using Flutter for the mobile app, Node.js for the backend, and Angular for the dashboard. I was responsible for both the backend and Angular parts, where I added new features and integrated various local payment solutions, such as Dashen Bank's MPGS, TeleBirr In-App payments for Ethiopia, and MoMo payments for South Sudan. I also developed RESTful APIs for these features to be integrated into both the Flutter app and Angular dashboard, and I handled the API integration within Angular. Additionally, working on the Zmall project gave me the opportunity to work with a remote server for the first time, enhancing my experience in managing server-side deployments.",
    tags: [],
    category: "android app",
    github: "https://play.google.com/store/apps/details?id=com.zmall.user",
    webapp: "https://www.zmalldelivery.com/",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
      {
        name: "Henok Cheklie",
        img: henok,
        linkedin: "https://www.linkedin.com/in/henok-cheklie",
        github: "https://github.com/henokcheklie",
      },
    ],
  },
  {
    id: 5,
    title: "Food Menu",
    date: "Apr 2022 - May 2022",
    description:
      "Developed the frontend of a food menu application using HTML, CSS, and JavaScript. Designed a visually appealing and responsive interface that allows users to browse and filter a variety of dishes seamlessly. Utilized an existing API to fetch the food list and related data, ensuring up-to-date content. Implemented interactive features for enhanced user engagement, focusing on user experience and accessibility across all devices.",
    image: foodMenuImage,
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23/forkify-CI-CD-",
    webapp: "https://foodmenu-eyop.netlify.app/",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 6,
    title: "Share Mangement System",
    date: "Apirl 2023 - Jun 2023",
    image: share_mng,
    description:
      "enable once to buy and increase share amount with integrated payment system and keep track of their share information and to dividend the share based on their share amount using next js as a front end,expressjs as a backend and mongodb as a database.",
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23/Share-Management-System",
    webapp: "https://share-mangement-sym.vercel.app/",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 8,
    title: "Dr. Yosef Specialty Dental Clinic - EMR System",
    date: "2025 - Present",
    image: dryosefdent,
    description:
      "Designed and built a fully custom Electronic Medical Records (EMR) system for Dr. Yosef Specialty Dental Clinic, now live in production. Spent time with the clinical team to understand real dental workflows before architecting the database, APIs, and clinical modules from scratch. Delivered patient management with auto-generated clinic IDs, appointment scheduling with conflict detection and automated SMS/email reminders, full EMR (clinical history, imaging, treatment planning, medical certificates), billing and invoicing, dental inventory tracking with low-stock and expiry alerts, role-based access for admins/doctors/receptionists/nurses, real-time notifications, and a public clinic website with online booking. Also handled production deployment, server configuration, API security, and infrastructure setup end-to-end.",
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23",
    webapp: "https://dryosefdent.com.et/",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
  {
    id: 7,
    title: "Furniture LandingPage",
    date: "Sep 2024",
    image: furniture,
    description:
      "Developed a modern landing page for a furniture store using React, Tailwind CSS, and Google Maps integration. Designed an intuitive and visually appealing interface showcasing the furniture collection, allowing users to explore products effortlessly. Integrated Google Maps to display the exact location of the store, helping users find it easily. Focused on creating a responsive design to ensure the website is accessible across all devices. Enhanced user interaction through clean layouts, smooth navigation, and optimized performance, providing a seamless and engaging experience for customers.",
    tags: [],
    category: "web app",
    github: "https://github.com/eyop23/furniture-website",
    webapp: "https://mamefurinture.netlify.app/",
    member: [
      {
        name: "Eyob Mekonnen",
        img: ephoto,
        linkedin: "https://www.linkedin.com/in/eyob-mekonnen-3997052aa/",
        github: "https://github.com/eyop23",
      },
    ],
  },
];

export const certifications = [
  {
    id: 0,
    title: "AWS Cloud Practitioner",
    date: "2024",
    description: "AWS Cloud Partitioning Course Certificate demonstrating foundational knowledge of AWS Cloud concepts, services, and terminology.",
    certificate: "https://drive.google.com/file/d/1TthIVMIm5U4To7fBjIWuhwFJtaTzjmmd/view?usp=drive_link",
    issuer: "Amazon Web Services (AWS)",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
